import { Colors } from "../constants/colors";
import { htmlStyles } from "./styles";

export default {
  styleOverrides: {
    root: {
      "& .MuiInputLabel-root": {
        "& .MuiInputLabel-asterisk": {
          color: Colors.RED400,
        },
        "&.Mui-focused": {
          "& .MuiInputLabel-asterisk": {
            color: Colors.BLUE500,
          },
        },
      },
    },
  },
  variants: [
    {
      props: { variant: "noBorder" },
      style: {
        backgroundColor: "#eaeaf2",
        color: "#2e2e38",
        border: "1px solid #eaeaf2",
        "&:hover": {
          color: "#2e2e38",
          backgroundColor: "#eaeaf2",
        },
      },
    },
    {
      props: { variant: "filled" },
      style: {
        "& .MuiInputBase-input": {
          ...htmlStyles.h6,
        },
        "& .MuiInputLabel-root": {
          ...htmlStyles.body1,
          // "&[data-shrink='false'] .MuiInputLabel-asterisk": {
          //   color: Colors.RED400,
          // },
          "&.MuiInputLabel-shrink": {
            fontSize: 12,
          },
          "&.Mui-focused": {
            color: Colors.BLUE500,
            // "& .MuiInputLabel-asterisk": {
            //   color: Colors.BLUE500,
            // },
          },
        },
        "& .MuiFilledInput-root": {
          backgroundColor: Colors.GREY100,
          "&:hover": {
            backgroundColor: Colors.GREY225,
          },
          "&.Mui-focused": {
            backgroundColor: Colors.GREY100,
          },
          "&.Mui-disabled": {
            backgroundColor: Colors.GREY50,
          },
          "&.Mui-disabled:before": {
            borderBottomStyle: "solid",
            borderColor: Colors.GREY300,
          },
          "&.Mui-focused:after": {
            borderColor: Colors.BLUE500,
          },
        },
      },
    },
  ],
};
